import React, { useEffect, useState, useRef, useCallback } from 'react';
import { apiCall, getBaseDir, moeda2float  } from '../../utils';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';

const BankReconciliationBodyRow = ({
  idx,
  bodyData,
  updateBodyData,
  removeBodyData,
  branches,
  installmentsSearchModalData,
  openedInstallmentSearchModal,
  renderInstallmentsSearchModalData,
  handleConciliate 
}) => {
  //console.log('BankReconciliationBodyRow', idx, bodyData);

  const [isTransfer, setIsTransfer] = useState(false);
  const createConciliationFormData = useRef(bodyData);
  const [formData, setFormData] = useState(bodyData);
  const movimentacaoId = useRef(bodyData.ID_TRANSACAO);
  const refFormData = useRef(bodyData);
  const hasInitializedSelect2Fields = useRef(false);
  const eventListenersInitialized = useRef(false);
  const debounceSearchInstallments = useRef(null);
  //console.log('movimentacaoId', movimentacaoId);

  // Atualizar formData quando bodyData mudar
  useEffect(() => {
    setFormData(bodyData);
    refFormData.current = bodyData;
  }, [bodyData]);  

  const handleDescricaoChange = (e) => {
    const newValue = e.target.value;
    setFormData(prev => ({
        ...prev,
        RECOMENDACAO: {
            ...prev.RECOMENDACAO,
            DESCRICAO: newValue
        }
    }));
    refFormData.current.RECOMENDACAO.DESCRICAO = newValue;
    refFormData.current.DESCRICAO = newValue;
};

  const handleSelect2Fields = () => {
    //console.log('handleSelect2Fields', hasInitializedSelect2Fields.current);
    if (hasInitializedSelect2Fields.current) return;
    hasInitializedSelect2Fields.current = true;

    $(`#filialDestino-${movimentacaoId.current}`).select2({
      placeholder: "Selecione uma filial",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-destination-container-${movimentacaoId.current}`),
      data: Object.values(branches).map(branch => ({
        id: branch.ID,
        text: branch.FILIAL
      }))
    });

    $(`#filialDestino-${movimentacaoId.current}`).on('select2:select', function(e) {
      createConciliationFormData.current.destinationBranchId = e.params.data.id;
      setFormData({
        ...formData,
        destinationBranchId: e.params.data.id
      });
      refFormData.current.destinationBranchId = e.params.data.id;
    });

    $(`.js-reconciliation-body-row-destination-branch-clear-button-${movimentacaoId.current}`).on('click', function() {
      $(`#filialDestino-${movimentacaoId.current}`).val('').trigger('change');
      createConciliationFormData.current.destinationBranchId = null;
      setFormData({
        ...formData,
        destinationBranchId: null
      });
      refFormData.current.destinationBranchId = null;
    });

    $(`#destino-${movimentacaoId.current}`).select2({
      placeholder: "Selecione uma conta financeira",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-destination-container-${movimentacaoId.current}`),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/accounts',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: v.CONTA,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
        return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    $(`#destino-${movimentacaoId.current}`).on('select2:select', function(e) {
      //console.log('change', e.params.data);
      createConciliationFormData.current.destinationId = e.params.data.id;
      setFormData({
        ...formData,
        destinationId: e.params.data.id
      });
      refFormData.current.destinationId = e.params.data.id;
    });

    
    $(`.js-reconciliation-body-row-destination-clear-button-${movimentacaoId.current}`).on('click', function() {
      $(`#filialDestino-${movimentacaoId.current}`).val('').trigger('change');
      createConciliationFormData.current.destinationId = null;
      setFormData({
        ...formData,
        destinationId: null
      });
      refFormData.current.destinationId = null;
    });

    // Seleciona o cliente
    $(`#cliente-${movimentacaoId.current}`).select2({
      placeholder: "Busque por telefone, nome ou email",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-customer-container-${movimentacaoId.current}`),
      minimumInputLength: 3,
      ajax: {
          url: getBaseDir() + 'api/v1/patient/search',
          delay: 1000,
          data: function(params) {
              var query = {
                  search: params.term,
                  branchId: createConciliationFormData.current.FILIAL_ID || -1,
                  page: params.page || 1
              }
              // Query parameters will be ?search=[term]&page=[page]
              return query;
          },
          processResults: function(data, params) {
              params.page = params.page || 1;

              var results = [];
              $.each(data.results, function(k, v) {
                  if (v.CONTRATOS != null) {
                      results.push({
                          id: v.ID,
                          text: `${v.TEXT}${v.CPF != null ? ` - ${v.CPF}` : ` - ${v.PASSAPORTE}`}`,
                          info: v
                      });
                  }
              });

              // Transforms the top-level key of the response object from 'items' to 'results'
              return {
                  results: results,
                  pagination: {
                      more: (params.page * 10) < data.count_filtered
                  }
              };
          }
      }
    });

    // Detecta alteração na seleção do cliente
    $(`#cliente-${movimentacaoId.current}`).on('select2:select', function(e) {
      createConciliationFormData.current.customerId = e.params.data.id;
      setFormData({
        ...formData,
        customerId: e.params.data.id
      });
      refFormData.current.customerId = e.params.data.id;
    });

    // Limpa a seleção do cliente
    $(`.js-reconciliation-body-row-customer-clear-button-${movimentacaoId.current}`).on('click', function() {
      $(`#cliente-${movimentacaoId.current}`).val('').trigger('change');
      createConciliationFormData.current.customerId = null;
      setFormData({
        ...formData,
        customerId: null
      });
      refFormData.current.customerId = null;
    });

    // Seleciona a categoria financeira
    $(`#categoria-${movimentacaoId.current}`).select2({
      placeholder: "Selecione uma categoria financeira",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-financial-category-container-${movimentacaoId.current}`),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/categories',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: createConciliationFormData.current.FILIAL_ID || -1,
            page: params.page || 1,
            type: formData.VALUE < 0 ? 'EXPENSE' : 'REVENUE'
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção da categoria financeira
    $(`#categoria-${movimentacaoId.current}`).on('select2:select', function(e) {
      createConciliationFormData.current.financialCategoryId = e.params.data.id;
      setFormData({
        ...formData,
        financialCategoryId: e.params.data.id
      });
      refFormData.current.financialCategoryId = e.params.data.id;
    });

    // Limpa a seleção da categoria financeira
    $(`.js-reconciliation-body-row-financial-category-clear-button-${movimentacaoId.current}`).on('click', function() {
      $(`#categoria-${movimentacaoId.current}`).val('').trigger('change');
      createConciliationFormData.current.financialCategoryId = null;
      setFormData({
        ...formData,
        financialCategoryId: null
      });
      refFormData.current.financialCategoryId = null;
    });

    // Seleciona a categoria financeira
    $(`#centroCusto-${movimentacaoId.current}`).select2({
      placeholder: "Selecione um centro de custo",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-cost-center-container-${movimentacaoId.current}`),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/cost-centers',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: createConciliationFormData.current.FILIAL_ID || -1,
            page: params.page || 1
          }
          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.results, function(k, v) {
            results.push({
              id: v.ID,
              text: `${v.CODIGO} - ${v.NOME}`,
              info: v
            });
          });

          // Transforms the top-level key of the response object from 'items' to 'results'
          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    // Detecta alteração na seleção do centro de custo
    $(`#centroCusto-${movimentacaoId.current}`).on('select2:select', function(e) {
      createConciliationFormData.current.financialCostCenterId = e.params.data.id;
      setFormData({
        ...formData,
        financialCostCenterId: e.params.data.id
      });
      refFormData.current.financialCostCenterId = e.params.data.id;
    });

    // Limpa a seleção do centro de custo
    $(`.js-reconciliation-body-row-cost-center-clear-button-${movimentacaoId.current}`).on('click', function() {
      $(`#centroCusto-${movimentacaoId.current}`).val('').trigger('change');
      createConciliationFormData.current.financialCostCenterId = null;
      setFormData({
        ...formData,
        financialCostCenterId: null
      });
      refFormData.current.financialCostCenterId = null;
    });

    // Seleciona o fornecedor
    $(`#fornecedor-${movimentacaoId.current}`).select2({
      placeholder: "Selecione um fornecedor",
      theme: 'bootstrap-5',
      dropdownParent: $(`.js-reconciliation-body-row-supplier-container-${movimentacaoId.current}`),
      minimumInputLength: 0,
      ajax: {
        url: getBaseDir() + 'api/v1/financial/suppliers',
        delay: 1000,
        data: function(params) {
          var query = {
            search: params.term,
            branchId: createConciliationFormData.current.FILIAL_ID || -1,
            page: params.page || 1
          }
          return query;
        },
        processResults: function(data, params) {
          params.page = params.page || 1;

          var results = [];
          $.each(data.data, function(k, v) {
            results.push({
              id: v.ID,
              text: v.NOME,
              info: v
            });
          });

          return {
            results: results,
            pagination: {
              more: (params.page * 10) < data.count_filtered
            }
          };
        }
      }
    });

    $(`#fornecedor-${movimentacaoId.current}`).on('select2:select', function(e) {
      createConciliationFormData.current.supplierId = e.params.data.id;
      setFormData({
        ...formData,
        supplierId: e.params.data.id
      });
      refFormData.current.supplierId = e.params.data.id;
    });

    $(`.js-open-search-financial-installments-modal-${movimentacaoId.current}`).on('click', function() {
      //console.log('open search financial installments modal');
      $('#modal-bank-reconciliation-search-financial-installments').modal('show');
      $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').block(window._loader.loading);
      if (refFormData.current.VALUE < 0) {
        $('#bank-reconciliation-confirm-installments').prop('disabled', true);
        $('#bank-reconciliation-confirm-partial-payment-installments').removeClass('d-none');
      } else {
        $('#bank-reconciliation-confirm-partial-payment-installments').addClass('d-none');
      }
      //console.log('refFormData', refFormData);
      openedInstallmentSearchModal.current = true;
      installmentsSearchModalData.current.searchValue = null;
      //installmentsSearchModalData.current.selectedDate = null;
      installmentsSearchModalData.current.fetchedData = [];
      installmentsSearchModalData.current.filteredData = false;
      installmentsSearchModalData.current.idx = null;
      fetchInstallmentSearchModalData();
    });

  }

  const unhandleSelect2Fields = () => {
    $(`.js-open-search-financial-installments-modal-${movimentacaoId.current}`).off('click');
    $(`.js-reconciliation-body-row-destination-clear-button-${movimentacaoId.current}`).off('click');
    $(`.js-reconciliation-body-row-customer-clear-button-${movimentacaoId.current}`).off('click');
    $(`.js-reconciliation-body-row-financial-category-clear-button-${movimentacaoId.current}`).off('click');
    $(`.js-reconciliation-body-row-cost-center-clear-button-${movimentacaoId.current}`).off('click');
    
    $(`.js-reconciliation-body-row-supplier-clear-button-${movimentacaoId.current}`).off('click');

    $(`#descricao-${movimentacaoId.current}`).off('change');
    $(`#flexSwitchCheckDefault-${movimentacaoId.current}`).off('change');
    try {
      $(`#filialDestino-${movimentacaoId.current}`).select2('destroy');
      $(`#destino-${movimentacaoId.current}`).select2('destroy');
      $(`#cliente-${movimentacaoId.current}`).select2('destroy');
      $(`#fornecedor-${movimentacaoId.current}`).select2('destroy');
      $(`#categoria-${movimentacaoId.current}`).select2('destroy');
      $(`#centroCusto-${movimentacaoId.current}`).select2('destroy');
    } catch(ex) {

    }
  }

  const handleIgnore = () => {
    Swal.fire({
      title: 'Ignorar lançamento',
      text: 'Tem certeza que deseja ignorar este lançamento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log('ignoring');
        apiCall({
          method: 'PUT',
          endpoint: 'api/v1/financial/bank_reconciliation/ignore',
          data: {
            id: bodyData.ID
          },
          successCallback: function(response) {
            //console.log('success', response);
            if (!response.error) {
              /*Swal.fire({
                title: 'Lançamento ignorado',
                icon: 'success'
              });*/
              window.toast({
                error: false,
                text: 'Lançamento ignorado'
              });
              removeBodyData(idx);
            }
          },
          errorCallback: function(response) {
            console.log('error', response);
          }
        })
      } else {
        //console.log('cancelled');
      }
    });
  }

  const handleUnlink = () => {
    const updatedBodyData = {
      ...bodyData,
      RECOMENDACAO: {
        ...bodyData.RECOMENDACAO,
        CLIENTE_ID: null,
        VENDA_ID: null,
        PARCELA_ID: null
      }
    };
    updateBodyData(idx, updatedBodyData);
    //console.log('handleUnlink', updatedBodyData);
  }

  const cleanupSelect2Instance = (elementId) => {
    try {
      const $element = $(`#${elementId}-${movimentacaoId.current}`);
      if ($element.length && $element.hasClass('select2-hidden-accessible')) {
        $element.select2('destroy');
      }
    } catch (ex) {
      console.debug(`Erro ao destruir select2 para ${elementId}`, ex);
    }
  };

  const cleanupAllEventListeners = useCallback(() => {
    try {
      // Limpar select2 com verificação de existência
      ['filialDestino', 'destino', 'cliente', 'fornecedor', 'categoria', 'centroCusto'].forEach(cleanupSelect2Instance);

      // Remover todos os event listeners
      const eventSelectors = [
        'js-open-search-financial-installments-modal',
        'js-reconciliation-body-row-destination-clear-button',
        'js-reconciliation-body-row-customer-clear-button',
        'js-reconciliation-body-row-financial-category-clear-button',
        'js-reconciliation-body-row-cost-center-clear-button',
        'js-reconciliation-body-row-supplier-clear-button',
        'js-reconciliation-body-row-destination-branch-clear-button'
      ];

      eventSelectors.forEach(selector => {
        $(`.${selector}-${movimentacaoId.current}`).off();
      });

      // Limpar listeners de elementos específicos
      ['descricao', 'flexSwitchCheckDefault'].forEach(elementId => {
        $(`#${elementId}-${movimentacaoId.current}`).off();
      });
      
      // Resetar flags
      hasInitializedSelect2Fields.current = false;
      eventListenersInitialized.current = false;
    } catch(ex) {
      console.error('Erro ao limpar event listeners:', ex);
    }
  }, []);



  const fetchInstallmentSearchModalData = (selectedDate = null, searchValue = null) => {
    const modalBody = $('#modal-search-financial-installments').find('.modal-body');
    modalBody.html('<div class="d-flex justify-content-center align-items-center"><div class="spinner-border" role="status"><span class="visually-hidden">Carregando...</span></div></div>');
    //console.log('bodyData', bodyData);

    let type = 'DESPESA';
    if (bodyData.VALUE < 0) {
      type = 'DESPESA';
    } else {
      type = 'RECEITA';
    }

    apiCall({
      method: 'GET',
      endpoint: 'api/v1/installments?notConciliated=true&branch=' + formData.FILIAL_ID + '&selectedDate=' + selectedDate + '&searchValue=' + searchValue + '&type=' + type,
      successCallback: function(response) {
        if (!response.error) {
          const currentValue = Math.abs(bodyData.VALUE); // Valor atual da movimentação
          const searchValue = $('#search-installments').val();
          const selectedDate = $('#search-installments-by-date').val();

          installmentsSearchModalData.current.currentValue = currentValue;
          installmentsSearchModalData.current.searchValue = searchValue;
          installmentsSearchModalData.current.selectedDate = selectedDate;
          installmentsSearchModalData.current.fetchedData = response.data;
          installmentsSearchModalData.current.formData = refFormData.current;
          installmentsSearchModalData.current.idx = idx;

          renderInstallmentsSearchModalData();
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
        } else {
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').html('<div class="alert alert-danger">Erro ao carregar lançamentos</div>');
          $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
        }
      },
      errorCallback: function(response) {
        console.log('error', response);
        window.toast({
          error: true,
          text: 'Erro ao carregar lançamentos.'
        });
        $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').html('<div class="alert alert-danger">Erro ao carregar lançamentos</div>');
        $('#modal-bank-reconciliation-search-financial-installments').find('.modal-body').unblock();
      }
    });
  }


  React.useEffect(() => {
    cleanupAllEventListeners();
    handleSelect2Fields();

    if (isTransfer === false) {
      setFormData(prev => ({
        ...prev,
        destinationBranchId: null,
        destinationId: null
      }));
      refFormData.current.destinationBranchId = null;
      refFormData.current.destinationId = null;
    } else {
      //console.log('branches', branches);
    }
    
    // Cleanup ao desmontar componente
    return () => {
      cleanupAllEventListeners();
    }
  }, [bodyData, isTransfer]);

  React.useEffect(() => {
    handleSelect2Fields();
    return () => {
      unhandleSelect2Fields();
    }
  }, []);

  //React.useEffect(() => {
    //console.log('createConciliationFormData', createConciliationFormData.current);
  //}, [createConciliationFormData.current]);

  return (
    <>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-5 col-lg-5">
          {idx === 0 ? <h6>Lançamentos do banco</h6> : ''}
          <div className="mb-3 card">
            <div className="card-body">
              <div className="row">
                <div className="col-1 col-sm-2 col-md-1 col-lg-1 d-flex justify-content-center items-center align-middle">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked={bodyData.CONCILIADO} />
                  </div>
                </div>
                <div className="col-5 col-sm-6 col-md-5 col-lg-5">
                  <h6>{moment(refFormData.current.DATA).tz('America/Sao_Paulo').format('DD/MM/YYYY')}</h6>
                </div>
                <div className="col-5 col-sm-4 col-md-5 col-lg-5 text-end">
                  <h6 className={refFormData.current.VALUE < 0 ? 'text-danger' : 'text-success'}><small>R$</small>{refFormData.current.VALUE}</h6>
                </div>
              </div>
              <div className="divider"></div>
              <p>{refFormData.current.DESCRIPTION}</p>
              <div className="divider"></div>
              <div className="row">
                <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                  <span className="badge bg-secondary">{refFormData.current.SOURCE == 'OFX' ? 'Integração manual' : 'Integração automática'}</span>
                </div>
                <div className="col-6 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end">
                  <button className="btn btn-secondary btn-sm" style={{height: '30px'}} onClick={handleIgnore}>
                    <i className="fa fa-trash"></i> Ignorar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-2 col-lg-2">
          <div className="d-flex justify-content-center items-center align-middle">
            <button className="btn btn-primary btn-sm" style={{height: '30px'}} onClick={() => handleConciliate(idx, [], refFormData.current)}>
              <i className="fas fa-plug"></i> Conciliar
            </button>
          </div>
        </div>
        <div className="col-sm-12 col-md-5 col-lg-5">
          {idx === 0 ? <h6>Lançamentos da conta</h6> : ''}
          <div className="mb-3 card">
            <div className="card-body">
              <div className="row">
                {refFormData.current?.RECOMENDACAO?.CLIENTE_ID && (
                  <>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      Venda {refFormData.current?.RECOMENDACAO?.VENDA_ID}
                    </div>
                    <div className="col-12 col-sm-12 col-md-6">
                      <span className="badge bg-secondary">
                        {refFormData.current?.RECOMENDACAO?.NOME_COMPLETO}
                      </span>
                    </div>
                    <div className="divider"></div>
                    <div className="row">
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                        <button className="btn btn-secondary btn-sm" style={{height: '30px'}}>
                          <i className="fa fa-edit"></i> Editar
                        </button>
                      </div>
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end">
                        <button className="btn btn-secondary btn-sm" style={{height: '30px'}} onClick={handleUnlink}>
                          <i className="fa fa-trash"></i> Desvincular
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {!refFormData.current?.RECOMENDACAO?.CLIENTE_ID && (
                  <>
                    <div className={`${isTransfer ? 'col-12' : 'col-12 col-sm-12 col-md-6 col-lg-6'}`}>
                      <div className="form-group">
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id={`flexSwitchCheckDefault-${movimentacaoId.current}`} checked={isTransfer} onChange={() => {
                            const newValue = !isTransfer;
                            setIsTransfer(!isTransfer)
                            if (newValue === false) {
                              setFormData(prev => ({
                                ...prev,
                                destinationBranchId: null,
                                destinationId: null
                              }));
                              refFormData.current.destinationBranchId = null;
                              refFormData.current.destinationId = null;
                            }
                          }} />
                          <label className="form-check-label" for={`flexSwitchCheckDefault-${movimentacaoId.current}`}>É uma transferência?</label>
                        </div>
                      </div>
                    </div>
                    {!isTransfer && (
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className="form-group">
                          <button type="button" className={`btn btn-secondary btn-sm js-open-search-financial-installments-modal-${movimentacaoId.current}`} style={{height: '30px'}}>
                            <i className="fa fa-search"></i> Buscar lançamentos
                          </button>
                        </div>
                      </div>
                    )}
                    <div className={`${!isTransfer ? 'col-12 col-md-6' : 'col-12'}`}>
                      <div className="form-group">
                        <label htmlFor={`descricao-${movimentacaoId.current}`}>Descrição</label>
                        <input type="text" id={`descricao-${movimentacaoId.current}`} className="form-control" value={refFormData.current?.RECOMENDACAO?.DESCRICAO || ''} onChange={handleDescricaoChange} />
                      </div>
                    </div>
                    {isTransfer && (
                      <>
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor={`filialDestino-${movimentacaoId.current}`}>Filial {refFormData.current.VALUE > 0 ? 'origem' : 'destino'}</label>
                            <select id={`filialDestino-${movimentacaoId.current}`} className="form-select js-business-branches-selector"></select>
                            <a href="#" className={`js-reconciliation-body-row-destination-branch-clear-button-${movimentacaoId.current}`}>
                              <i className="fa fa-trash mt-2"></i> Limpar
                            </a>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className={`form-group js-reconciliation-body-row-destination-container-${movimentacaoId.current}`}>
                            <label htmlFor={`destino-${movimentacaoId.current}`}>Conta {refFormData.current.VALUE > 0 ? 'origem' : 'destino'}</label>
                            <select id={`destino-${movimentacaoId.current}`} className="form-select"></select>
                            <a href="#" className={`js-reconciliation-body-row-destination-clear-button-${movimentacaoId.current}`}>
                              <i className="fa fa-trash mt-2"></i> Limpar
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                    {!isTransfer && (
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className={`form-group js-reconciliation-body-row-financial-category-container-${movimentacaoId.current}`}>
                          <label htmlFor={`categoria-${movimentacaoId.current}`}>Categoria</label>
                          <select id={`categoria-${movimentacaoId.current}`} className="form-select"></select>
                          <a href="#" className={`js-reconciliation-body-row-financial-category-clear-button-${movimentacaoId.current}`}>
                            <i className="fa fa-trash mt-2"></i> Limpar
                          </a>
                        </div>
                      </div>
                    )}
                    {!isTransfer && refFormData.current.TIPO == '0' && (
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className={`form-group js-reconciliation-body-row-customer-container-${movimentacaoId.current}`}>
                          <label htmlFor={`cliente-${movimentacaoId.current}`}>Cliente</label>
                          <select id={`cliente-${movimentacaoId.current}`} className="form-select"></select>
                          <a href="#" className={`js-reconciliation-body-row-customer-clear-button-${movimentacaoId.current}`}>
                            <i className="fa fa-trash mt-2"></i> Limpar
                          </a>
                        </div>
                      </div>
                    )}
                    {!isTransfer && refFormData.current.TIPO == '1' && (
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className={`form-group js-reconciliation-body-row-supplier-container-${movimentacaoId.current}`}>
                          <label htmlFor={`fornecedor-${movimentacaoId.current}`}>Fornecedor</label>
                          <select id={`fornecedor-${movimentacaoId.current}`} className="form-select"></select>
                          <a href="#" className={`js-reconciliation-body-row-supplier-clear-button-${movimentacaoId.current}`}>
                            <i className="fa fa-trash mt-2"></i> Limpar
                          </a>
                        </div>
                      </div>
                    )}
                    {!isTransfer && (
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div className={`form-group js-reconciliation-body-row-cost-center-container-${movimentacaoId.current}`}>
                          <label htmlFor={`centroCusto-${movimentacaoId.current}`}>Centro de custo</label>
                          <select id={`centroCusto-${movimentacaoId.current}`} className="form-select"></select>
                          <a href="#" className={`js-reconciliation-body-row-cost-center-clear-button-${movimentacaoId.current}`}>
                            <i className="fa fa-trash mt-2"></i> Limpar
                          </a>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider"></div>
    </>
  )
}
export default BankReconciliationBodyRow;